<template>
  <div class="modal-wrap modal-wrap--35">
    <div class="modal-header">
      <p class="mb-15 bold">Redigera bud</p>
    </div>

    <div class="modal-content">

      <input type="text" inputmode="numeric" class="width-100" @input="priceFormatted(bid)" v-model="bid" placeholder="Bud">
      <div class="grid2col mt-15 mb-25">
        <div><input type="date" class="width-100" v-model="date"></div>
        <div><input type="time" v-model="time" class="width-100"></div>
      </div>

      <div class="flex align-middle mb-15">
        <label class="switch mr-10" style="width: 33px;">
          <input type="checkbox" class="mr-5" v-model="confirmedForPublish">
          <div class="slider round"></div>
        </label>
        <span class="pl-15">Godkänd för publicering</span>
      </div>
      <div class="flex align-middle">
        <label class="switch mr-10 width-50">
          <input type="checkbox" class="mr-5" v-model="hide">
          <div class="slider round"></div>
        </label>
        <span class="pl-15">Detta är ett dolt bud som inte är godkänt att publicera på internet.</span>
      </div>

      <input type="text" placeholder="Budlista kommentar" v-model="comment" class="mt-25 width-100">
      <input type="text" placeholder="Intern kommentar" v-model="commentInternal" class="mt-15 width-100">

      <!-- radera bud -->
      <button class="width-100 outline mt-50" @click="deleteBid">radera bud...</button>
    </div>


    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editBid',
  data() {
    return {
      // todo: check if it is possible to remove newDate and newTime.
      newDate: '',
      newTime: ''
    }
  },
  computed: {
    /**
     * Since we get date and time in one string we need to handle that.
     */
    date:{
      get() {
        let getDate = '';
        if (this.newDate) {
          getDate = this.newDate;
        } else {
          getDate = this.$store.state.editBid.date.split(" ")[0];
        }
        return getDate;
      },
      set(v) {
        this.newDate = v;
        let date = '';
        // If time is changed, we have to add :00 for the correct time format.
        if (this.newTime) {
          date = v + " " + this.time + ":00";
        } else {
          date = v + " " + this.time;
        }
        this.$store.commit("SET_EDIT_BID_DATE", date);
      }
    },
    time: {
      get() {
        /*
        * Todo: This is needed because otherwise it's only possible to type in one number at the time.
        * If i want to change the time to 13.00, the result becomes first 01 and then 03 when pressing number 3.
        * Therefore checking if time has been updated.
        */
        let getTime = '';
        if (this.newTime) {
          getTime = this.newTime;
        } else {
          getTime = this.$store.state.editBid.date.split(" ")[1];
        }
        return getTime;
      },
      set(v) {
        this.newTime = v;

        const date = this.date + " " + v + ":00";
        this.$store.commit("SET_EDIT_BID_DATE", date);
      }
    },
    bid: {
      get() {
        return this.priceFormatted(this.$store.state.editBid.amount.toString());
      },
      set(v){
        this.$store.commit("SET_EDIT_BID_AMOUNT", v);
      }
    },
    comment: {
      get() {
        return this.$store.state.editBid.comment;
      },
      set(v) {
        this.$store.commit("SET_EDIT_BID_COMMENT", v);
      }
    },
    commentInternal: {
      get() {
        return this.$store.state.editBid.commentInternal;
      },
      set(v) {
        this.$store.commit("SET_EDIT_BID_COMMENT_INTERNAL", v);
      }
    },
    hide: {
      get() {
        return this.$store.state.editBid.hide;
      },
      set(v) {
        const newHide = v ? 1 : 0;
        this.$store.commit("SET_EDIT_BID_HIDE", newHide);
      }
    },
    confirmedForPublish: {
      get() {
        return this.$store.state.editBid.confirmedForPublish;
      },
      set(v) {
        let newVal = v ? 1 : 0;
        this.confirmedForPublishValueChanged = true;
        this.$store.commit("SET_EDIT_BID_CONFIRMEDFORPUBLISH", newVal);
      }
    }
  },
  methods: {
    priceFormatted(bid) {
      if (!bid) {
        return 0
      }
      let aux = parseInt(bid.replace(/ /g, ''));
      if (aux > 0) {
        return this.$root.formatPrice(aux);
      }
    },
    deleteBid() {
      this.$root.modalOpen = false;
      this.$emit('submitted', { component: "deleteBid" });
    },
    abort() {
      this.resetEditBid();
      this.$root.modalOpen = false;
    },
    resetEditBid() {
      // Todo: For some reason store becomes unreactive if setting back to null...very strange.
      // this.$store.commit('SET_EDIT_BID', null);
    },
    save() {
      let amount = this.bid.replace(/\s+/g, '');
      let data = {
        "id": this.$store.state.editBid.id,
        "objectId": this.$route.params.id,
        "amount": amount,
        "hide": this.$store.state.editBid.hide,
        "comment": this.$store.state.editBid.comment,
        "commentInternal": this.$store.state.editBid.commentInternal,
        "confirmedForPublish": this.$store.state.editBid.confirmedForPublish,
        "date": this.$store.state.editBid.date
      }

      this.$root.callFasAdApi("/internalapi/bid/edit", "POST", data)
      .then((data) => {
        this.resetEditBid();
        this.$root.modalOpen = false;
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
        this.$root.handleResponseMessage(data);

        // If toggle confirmed for pulished is set to true add sms/e-mail popup.
        if (this.$store.state.editBid.confirmedForPublish && this.confirmedForPublishValueChanged) {
          // after new bid, show modal depending on settings
          if (this.$store.state.currentListingWithBiddings.bidSettings.bidSendAllowed > 0) {
            let deliveryType = this.$store.state.currentListingWithBiddings.bidSettings.bidSendAllowed === 1 ? 'sms' : 'email';

            let notifyThesePeople = this.$store.getters.notifyThesePeople;

            this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', deliveryType);
            this.$store.commit('STORE_SMS_MAIL_RECIEVERS', notifyThesePeople);

            // Get message template
            this.$root.callFasAdApi("/internalapi/message-template/get-bid-standard/objectId/" + this.$route.params.id)
                .then((data) => {
                  if (data.status === 200) {
                    this.$store.commit('STORE_SMS_MAIL_SUBJECT', data.data.subject);
                    this.$store.commit('STORE_SMS_MAIL_CONTENT', data.data.content);
                    this.$store.commit('STORE_SMS_MAIL_CHOSEN_MESSAGING_TEMPLATE', data.data.id);
                  }
                })
                .catch(console.error);
            setTimeout(() => {
              this.$emit('submitted', { component: "sendSmsOrMail" });
            }, 1200);
          }
        }
      })
      .catch(console.error);
    }
  }
}
</script>